import type { OrderRequestTableQuery } from 'pages/request/order/models';

import type {
  CancelOrCompleteOrderRequestRequest,
  LinkCustomerToOrderRequestRequest,
  LinkOrdersToOrderRequestRequest,
  OrderRequestDetail,
  OrderRequestToAdd,
  OrderRequestToEdit,
  PublicGetOrderRequestDataQueryResult,
  PublicOrderRequestToAdd,
  TableResultOrderRequest
} from './models/mainservice';
import { protectedApiClient } from './support/baseApiClients';
import { apiClient } from './support/unprotectedBaseApiClients';

export default {
  getPublicOrderRequestData: async (tenantCode: string, publicFormCode: string) => {
    const result = await apiClient.get<PublicGetOrderRequestDataQueryResult>(
      `/public/orderRequest/${tenantCode}/${publicFormCode}`
    );
    return result.data;
  },
  addOrderRequestData: async (params: {
    tenantCode: string;
    publicFormCode: string;
    requestToAdd: PublicOrderRequestToAdd;
  }) => {
    const result = await apiClient.post<undefined>(
      `/public/orderRequest/${params.tenantCode}/${params.publicFormCode}`,
      params.requestToAdd
    );
    return result.data;
  },
  getOrderRequests: async (params: OrderRequestTableQuery) => {
    const result = await protectedApiClient.get<TableResultOrderRequest>('/orderRequest', {
      params
    });
    return result.data;
  },
  getDetail: async (requestId: string) => {
    const result = await protectedApiClient.get<OrderRequestDetail>(`/orderRequest/${requestId}`);
    return result.data;
  },
  edit: async (params: { orderRequestId: string; values: OrderRequestToEdit }) => {
    const result = await protectedApiClient.put<OrderRequestDetail>(
      `/orderRequest/${params.orderRequestId}`,
      params.values
    );

    return result.data;
  },
  cancel: async (params: {
    orderRequestId: string;
    values: CancelOrCompleteOrderRequestRequest;
  }) => {
    const result = await protectedApiClient.put<undefined>(
      `/orderRequest/${params.orderRequestId}/cancel`,
      params.values
    );

    return result.data;
  },
  complete: async (params: {
    orderRequestId: string;
    values: CancelOrCompleteOrderRequestRequest;
  }) => {
    const result = await protectedApiClient.put<undefined>(
      `/orderRequest/${params.orderRequestId}/complete`,
      params.values
    );

    return result.data;
  },
  delete: async (orderRequestId: string) => {
    const result = await protectedApiClient.delete<undefined>(`/orderRequest/${orderRequestId}`);

    return result.data;
  },
  addOrderRequest: async (values: OrderRequestToAdd) => {
    const result = await protectedApiClient.post<undefined>('/orderRequest', values);

    return result.data;
  },
  linkCustomer: async (params: {
    orderRequestId: string;
    values: LinkCustomerToOrderRequestRequest;
  }) => {
    const result = await protectedApiClient.put<undefined>(
      `/orderRequest/${params.orderRequestId}/linkCustomer`,
      params.values
    );

    return result.data;
  },
  linkOrders: async (params: {
    orderRequestId: string;
    values: LinkOrdersToOrderRequestRequest;
  }) => {
    const result = await protectedApiClient.put<undefined>(
      `/orderRequest/${params.orderRequestId}/linkOrders`,
      params.values
    );

    return result.data;
  }
};
